import { Routes } from '@angular/router';
import { ViewWorkshopJobComponent } from './view-workshop-job/view-workshop-job.component';
import { WorkshopIndexComponent } from './workshop-index/workshop-index.component';
import { TemplateIndexComponent } from './workshop-job-templates/template-index/template-index.component';

export const workshopRoutes: Routes = [
  {
    path: '',
    component: WorkshopIndexComponent,
    title: 'Workshop Jobs'
  },
  {
    path: 'job/:id',
    component: ViewWorkshopJobComponent,
    title: 'Workshop Job'
  },
  {
    path: 'templates',
    component: TemplateIndexComponent,
    title: 'Workshop Job Templates'
  }
];